export const PREMIUM_SUBSCRIPTION_MONTHLY_PRICE = '288 Kč';
export const PREMIUM_SUBSCRIPTION_MONTHLY_PRICE_WITH_VAT = '349 Kč';

export const PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE = '1 587 Kč';
export const PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE_WITH_VAT = '1 920 Kč';

export const PREMIUM_SUBSCRIPTION_YEARLY_PRICE = '2 884 Kč';
export const PREMIUM_SUBSCRIPTION_YEARLY_PRICE_WITH_VAT = '3 490 Kč';
